import { Injectable } from "@angular/core";
import {
    HttpHandler,
    HttpRequest,
    HttpInterceptor,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { MessageService } from "primeng/api";

@Injectable({
    providedIn: "root",
})
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private auth: AuthModel,
        private messageService: MessageService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(
            catchError((error) => {
                let errorMessage = "";
                if (typeof error === "string") {
                    this.messageService.add({
                        severity: "warn",
                        summary: "Api Error",
                        detail: error,
                        key: "root-msg"
                    });
                } else {
                    if (error instanceof ErrorEvent) {
                        errorMessage = `Client-side error: ${error.error.message}`;
                    } else {
                        if (error.status == 401 && error.error === "Token-Expired") {
                            this.auth.refreshToken().subscribe((data: any) => {
                                this.auth.setJwsTokenCookie(data.token, data.refreshToken);
                            });
                        } else if (error.status == 401 && error.error === "Refresh token Expired") {
                            this.auth.resetUserCookie();
                        } else {
                            this.messageService.add({
                                severity: "warn",
                                summary: "Api Error",
                                detail: `Server-side error: ${error.status} -- ${error.message}`,
                                key: "root-msg"
                            });
                        }
                        errorMessage = `Server-side error: ${error.status} -- ${error.message}`;
                    }
                }
                return throwError(errorMessage);
            })
        );
    }
}
